module.exports = __webpack_public_path__ + "img/starperformers-head@2x.f674a144.png";